import React from 'react';
import { useField } from 'formik';
import { makeStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Typography from '@material-ui/core/Typography';

import { requiredFields } from '../FormPage/FormPage';

const useStyles = makeStyles(theme => ({
  formControl: {
    display: 'block',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
}));

type YesNoFieldProps = {
  label: React.ReactNode,
  name: string,
  required?: boolean,
};

const YesNoField = ({ label, name, required }: YesNoFieldProps) => {
  const classes = useStyles();
  const [field, meta] = useField(name);
  const isRequired = required || requiredFields[name];
  const hasError = meta.touched && !!meta.error;

  return (
    <FormControl component="fieldset" className={classes.formControl} error={hasError}>
      <FormLabel component="legend">
        {label} {!isRequired && <Typography variant="caption">(optional)</Typography>}
      </FormLabel>
      <RadioGroup {...field} name={name} row>
        <FormControlLabel control={<Radio />} label="Yes" value="True" />
        <FormControlLabel control={<Radio />} label="No" value="False" />
      </RadioGroup>
      {hasError && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
}

export default YesNoField;
